import * as React from 'react';

import { HoverCard, IExpandingCardProps } from 'office-ui-fabric-react/lib/HoverCard';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';
import isRoom from '../utils/isRoom';
import createLocationPersonaFromPostalAddress from '../utils/createLocationPersonaFromPostalAddress';
import isEnhancedLocation from '../utils/isEnhancedLocation';
import LocationCompactCard from './LocationCompactCard';
import LocationExpandedCard from './LocationExpandedCard';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import getLocationTextStyle from '../utils/getLocationTextStyle';

export interface LocationCardWrapperProps {
    name: string;
    postalAddress: PersonaPostalAddress;
    children?: JSX.Element | JSX.Element[];
    colorScheme?: ColorScheme;
}

export interface LocationCardWrapperState {
    expandingCardProps: IExpandingCardProps;
    locationPersona: LocationPersonaControlViewState;
}

export interface LocationCardProps {
    locationPersona: LocationPersonaControlViewState;
}

export class LocationCardWrapper extends React.Component<
    LocationCardWrapperProps,
    LocationCardWrapperState
> {
    constructor(props: LocationCardWrapperProps) {
        super(props);
        let { postalAddress, name } = this.props;
        let expandedCardHeight = 0;
        if (postalAddress) {
            if (
                postalAddress.Street ||
                (postalAddress.LocationUri && !isRoom(this.props.postalAddress))
            ) {
                expandedCardHeight += 110;
            }
            if (postalAddress.Latitude && postalAddress.Longitude) {
                expandedCardHeight += 217;
            }
        }

        this.state = {
            expandingCardProps: {
                compactCardHeight: 93,
                expandedCardHeight: expandedCardHeight,
                onRenderCompactCard: this.onRenderCompactCard,
                onRenderExpandedCard: this.onRenderExpandedCard,
            },
            locationPersona: createLocationPersonaFromPostalAddress(postalAddress, name),
        };
    }

    render(): JSX.Element {
        if (isEnhancedLocation(this.props.postalAddress)) {
            return (
                <HoverCard
                    cardDismissDelay={300}
                    trapFocus={true}
                    expandingCardProps={{
                        renderData: this.state.locationPersona,
                        ...this.state.expandingCardProps,
                    }}
                    instantOpenOnClick={true}>
                    <span className={getLocationTextStyle(this.props.colorScheme)} tabIndex={0}>
                        {this.props.children}
                    </span>
                </HoverCard>
            );
        }
        return <span>{this.props.children}</span>;
    }

    private onRenderCompactCard = (locationPersona: any): JSX.Element => {
        return <LocationCompactCard locationPersona={locationPersona} />;
    };

    private onRenderExpandedCard(locationPersona: any): JSX.Element {
        return <LocationExpandedCard locationPersona={locationPersona} />;
    }
}
